import Cookies from "js-cookie";
import { UserSettings } from "../models/UserSettings";

export function register(email: string, username: string, password: string) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/auth/signup';
    return fetch(api_path, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({'email': email, 'username': username, 'password': password})
    }).then(response => {
        return response.json();
    });
}

export function login(username: string, password: string) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/auth/signin';
    return fetch(api_path, {
        method: 'POST', 
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({'username': username, 'password': password})
    });
}

export function getCurrentUser() {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/auth/user';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    }).then(response => {
        return response.ok ? response.json() : null;
    });
}

export function changeUserSettings(userSettings: UserSettings) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/auth/usersettings';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(userSettings)
    });
}

export function changePassword(newPassword: string) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/auth/password';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({'newPassword': newPassword})
    });
}

export function getAllUsernames() {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/auth/users';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response.ok ? response.json() : [];
    });
}
